import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { COMPANY } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { toWaNumber } from "@/components/ConfirmVisitDialog";

export const RatingLinkDialog = ({ open, onClose, insp, onSent }) => {
  const { user } = useAuth();
  const [cc, setCc] = useState("");
  const [number, setNumber] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!open) return;
    api.get("/settings").then(({ data: s }) => {
      setCc(s.country_code || "");
      setNumber(toWaNumber(insp.customer.phone, s.country_code));
    });
    setMsg(`شكراً ${insp.customer.name} لاستقبالكم مندوب ${COMPANY} (${insp.agent_name}).\nنسعد بتقييمكم للزيارة في أقل من دقيقة:`);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const send = async () => {
    const n = toWaNumber(number, cc);
    if (!n) return toast.error("رقم العميل غير صالح؛ أدخله مع رمز الدولة");
    const win = window.open("", "_blank");
    try {
      const { data } = await api.post(`/inspections/${insp.id}/rating-link`);
      const url = `https://wa.me/${n}?text=${encodeURIComponent(`${msg}\n${window.location.origin}${data.path}`)}`;
      if (win) win.location.href = url;
      else window.location.href = url;
      if (user.role === "admin" && /^\d{1,4}$/.test(cc)) api.put("/settings", { country_code: cc }).catch(() => {});
      onSent?.(data.inspection);
      onClose();
    } catch (e) {
      win?.close();
      toast.error(errMsg(e));
    }
  };

  const local = (insp.customer.phone || "").replace(/\D/g, "").startsWith("0");
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="max-w-lg" data-testid="rating-link-dialog">
        <DialogHeader><DialogTitle className="text-start font-heading flex items-center gap-2"><Star size={18} className="text-amber-500" />إرسال رابط التقييم للعميل</DialogTitle></DialogHeader>
        <div className="grid grid-cols-3 gap-2">
          {local && <Input value={cc} onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 4); setCc(v); setNumber(toWaNumber(insp.customer.phone, v)); }} placeholder="رمز الدولة" disabled={user.role !== "admin" && !!cc} dir="ltr" className="text-left" data-testid="rating-country-code" />}
          <Input value={number} onChange={(e) => setNumber(e.target.value)} placeholder="رقم العميل الدولي" dir="ltr" className={`text-left ${local ? "col-span-2" : "col-span-3"}`} data-testid="rating-phone-input" />
        </div>
        <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={4} data-testid="rating-message-input" />
        <p className="text-xs text-slate-500">يُضاف الرابط القصير تلقائياً في نهاية الرسالة. يمكن للعميل التقييم مرة واحدة.</p>
        <button onClick={send} data-testid="rating-send-whatsapp" className="h-12 rounded-lg bg-[#25D366] text-white font-bold hover:bg-[#1EB257]">إرسال عبر واتساب</button>
      </DialogContent>
    </Dialog>
  );
};
